
































import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import Warning from '~/components/JetUi/atoms/Warning/Warning.vue';
import AddressForm from '~/components/JetUi/organisms/Checkout/AddressForm.vue';
import UserAddresses from '~/modules/checkout/components/UserAddresses.vue';
import { useCheckoutStore } from '~/stores/checkout';
import JetInput from '../../atoms/Input/JetInput.vue';

export default defineComponent({
  name: 'AddressSummary',
  components: {
    JetInput,
    Warning,
    AddressForm,
    UserAddresses,
  },
  setup() {
    const checkoutStore = useCheckoutStore();
    const { isAuthenticated, addresses } = storeToRefs(checkoutStore);
    const showForm = ref(false);
    const loading = ref(true);

    onMounted(() => {
      loadAddresses();
    });

    const loadAddresses = () => {
      setTimeout(() => {
        showForm.value = (addresses.value.length === 0);
        loading.value = false;
      }, 1000);
    };

    return {
      isAuthenticated,
      showForm,
      addresses,
      loading,
    };
  },
});
